"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dialog = void 0;
var React = __importStar(require("react"));
var utils_1 = require("../../utils");
var types_1 = require("../../types");
var Dialog_style_1 = require("./Dialog.style");
exports.Dialog = function (_a) {
    var _b, _c, _d, _e;
    var id = _a.id, content = _a.content, actions = _a.actions, config = _a.config;
    var _f = utils_1.useFusionContext(), state = _f.state, dispatch = _f.dispatch;
    var refContainer = React.useRef(null);
    var refDialog = React.useRef(null);
    React.useEffect(function () {
        var container = refContainer.current;
        var dialog = refDialog.current;
        if (container && dialog) {
            utils_1.animate(function (value) { return (container.style.opacity = value); }, { from: parseFloat(container.style.opacity), to: 1 });
            utils_1.animate(function (value) { return (dialog.style.transform = "scale(" + value + ")"); }, { from: utils_1.sliceFloat(dialog.style.transform), to: 1 });
        }
    }, []);
    var closeDialog = function () {
        var container = refContainer.current;
        var dialog = refDialog.current;
        if (container && dialog) {
            utils_1.animate(function (value) { return (container.style.opacity = value); }, { from: parseFloat(container.style.opacity), to: 0 });
            utils_1.animate(function (value) { return (dialog.style.transform = "scale(" + value + ")"); }, {
                from: utils_1.sliceFloat(dialog.style.transform),
                to: 0,
                onRest: function () { return dispatch({ type: types_1.ActionType.REMOVE_DIALOG, payload: id }); }
            });
        }
    };
    var closeIfContainer = function (e) {
        if (e.target.dataset.autoclose === "true") {
            closeDialog();
        }
    };
    var actionOnClick = function (callback) {
        callback ? callback() : null;
        closeDialog();
    };
    return (React.createElement("div", { ref: refContainer, className: (_b = state.dialogClassNames) === null || _b === void 0 ? void 0 : _b.container, style: __assign(__assign({}, Dialog_style_1.containerStyles), { cursor: (config === null || config === void 0 ? void 0 : config.autoclose) ? "pointer" : undefined }), onClick: (config === null || config === void 0 ? void 0 : config.autoclose) ? function (e) { return closeIfContainer(e); } : undefined, "data-autoclose": config === null || config === void 0 ? void 0 : config.autoclose },
        React.createElement("div", { ref: refDialog, className: (_c = state.dialogClassNames) === null || _c === void 0 ? void 0 : _c.dialog, style: Dialog_style_1.dialogStyles },
            React.createElement("div", { className: (_d = state.dialogClassNames) === null || _d === void 0 ? void 0 : _d.content }, content),
            React.createElement("div", { className: (_e = state.dialogClassNames) === null || _e === void 0 ? void 0 : _e.actionContainer }, actions.map(function (action, index) {
                var _a, _b, _c;
                return (React.createElement("button", { key: id + "-" + index, className: ((_a = state.dialogClassNames) === null || _a === void 0 ? void 0 : _a.action) + (((_b = state.dialogClassNames) === null || _b === void 0 ? void 0 : _b.highlight) && action.highlight ? " " + state.dialogClassNames.highlight : ""), onClick: function () { return actionOnClick(action.callback); } },
                    React.createElement("span", { className: (_c = state.dialogClassNames) === null || _c === void 0 ? void 0 : _c.actionLabel }, action.label)));
            })))));
};
